// extracted by mini-css-extract-plugin
export default {"center":"CurrencyTab_center__4TSAD"};